import {
  Sensor,
  SensorApiFilter,
} from '@energybox/react-ui-library/dist/types';
import { fetchApi } from '../utils/apiUtils';
import { setSensorApiFilter } from './sensors';

export const fetchSensors = (filter?: SensorApiFilter): Promise<Sensor[]> =>
  fetchApi({ endpoint: setSensorApiFilter(filter) });
